import { IOption } from 'lib_ts/interfaces/common/i-option';

export const MIN_TRAINING_CONFIDENCE = 0.9;

export enum ProgressDirection {
  Next = 1,
  Prev = -1,
}

export enum TrainStep {
  // separate step from firing to prevent firing while sending
  Sending = 'Sending',
  Firing = 'Firing',
  // waiting for training responses to aggregate
  Waiting = 'Waiting',
  // adjusting a shot already created (e.g. with rapsodo)
  ManualAdjust = 'ManualAdjust',
  // inputting plate location to create a shot (e.g. with manual training)
  ManualInput = 'ManualInput',
  // after manual input, if still waiting on other detections (e.g. MSBS is busted)
  Complete = 'Complete',
}

export enum PTStep {
  // i.e. collect more data
  Sending = 'Sending',
  Firing = 'Firing',
  Waiting = 'Waiting',
  Complete = 'Complete',
  Iterate = 'Iterate',
}

// minimum will be the machine's training threshold, to prevent selection of anything less
export const getSampleSizes = (minimum: number) => {
  const output: IOption[] = [];

  for (let i = minimum; i <= 25; i++) {
    // i.e. min to 10, 15, 20, 25
    if (i <= 10 || i % 5 === 0) {
      output.push({
        label: i.toString(),
        value: i.toString(),
      });
    }
  }

  return output;
};

// for filtering logs by subsets of TrainingOutcome values
export enum PseudoTrainingOutcome {
  Complete = 'complete',
  PT_Failure = 'pt-failure',
  GiveUp = 'give-up',
}
